<!-- =========================================================================================
  File Name: ChartjsComponentBarChart.vue
  Description: Chartjs component - Bar Chart
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<script>
import { Bar } from 'vue-chartjs'

// eslint-disable-next-line no-unused-vars
export default {
  extends: Bar,
  data () {
    return {
      data: {
        labels:[],
        datasets: [
          {
            label: '',
            backgroundColor: [],
            data:[]
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: ''
        }
      }
    }
  },
  mounted () {
    this.$http.get('dashboardAdmin/')
      .then((response) => {
        if (response.data.letters_analytics && response.data.letters_analytics.by_corporate) {
        // Liste complète des mois utilisés dans les données
          const months = [
            'month_1', 'month_2', 'month_3', 'month_4', 'month_5', 'month_6',
            'month_7', 'month_8', 'month_9', 'month_10', 'month_11', 'month_12'
          ]

          // Labels affichés sur le graphe
          const monthLabels = [
            'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
            'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
          ]

          // Mois courant (1-12)
          const currentMonthNumber = new Date().getMonth() + 1

          // Tronquer les labels et les mois de données
          const visibleLabels = monthLabels.slice(0, currentMonthNumber)
          const visibleMonths = months.slice(0, currentMonthNumber)

          // Affecter labels tronqués
          this.data.labels = visibleLabels

          // Construire les datasets pour chaque corporate
          this.data.datasets = Object.values(response.data.letters_analytics.by_corporate).map((corp, idx) => ({
            label: corp.corporate_name,
            backgroundColor: `hsl(${idx * 20}, 90%, 60%)`,
            borderColor: `hsl(${idx * 20}, 90%, 60%)`,
            data: visibleMonths.map(m => corp.letters_by_month[m] || 0)
          }))
        }

        // Rendu du graphique
        this.renderChart(this.data, this.options)
      })
  }

}
</script>
